<template lang="pug">
  .page
    form(@submit.prevent="onSubmit")
      .field.brand
        h1 Tonypedia
      .field
        .control
          label.label Email
          input.input(v-model="user.email", name="email")
      .field
        .control
          label.label Password
          input.input(type="password", v-model="user.password")
          .error {{ error }}
      .field.button-field
        .control
          button.button.is-primary(type="submit", :class="{ 'is-loading': submitting }") Login
</template>
<script>
export default {
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      submitting: false,
      error: ''
    }
  },
  methods: {
    onSubmit () {
      this.submitting = true
      this.error = ''
      this.$store
        .dispatch('auth/signin', this.user)
        .then(response => {
          this.submitting = false
          this.error = ''
          if (this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect })
          } else {
            this.$router.push({ path: '/' })
          }
        })
        .catch(err => {
          this.submitting = false
          if (err.message) {
            this.error = err.message
          } else {
            console.log(err)
            this.error = 'Cannot connect to API Server'
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh);
  }
  form {
    width: 320px;
    margin: 20px auto;
    color: white;
  }
  .label {
    color: white;
  }
  .button {
    width: 100%;
  }
  .button-field {
    margin-top: 30px;
  }
  .error {
    margin: 10px 0;
    color: red;
  }
  .brand {
    h1 {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/auth/Signin.vue